"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    // *** Transaction Tapes ***
    noteRawTapeArtifactSlug: zod_1.z.string().describe('Note raw tape artifact slug'),
    participantRawTapeArtifactSlug: zod_1.z
        .string()
        .describe('Participant raw tape artifact slug'),
    noteTransactionArtifactSlug: zod_1.z
        .string()
        .describe('Note transaction artifact slug'),
    participantTransactionArtifactSlug: zod_1.z
        .string()
        .describe('Participant transaction artifact slug'),
});
exports.nodeType = 'file_valley_bank_sls_ingest';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'valleyBankSlsIngest';
//# sourceMappingURL=types.js.map